// Sort the array of posts/ideas that every view (calendar / list /
// kanban) renders against, so the page's sort toggle drives ALL views
// — not just the legacy keyword-filter path.
//
// History: existing callers used `sortByDate(arr, FROM_NEWER_TO_OLDER,
// 'scheduled_at')` (positional args), but sortByDate's signature is
// `(data, opts)` — the constants and field name landed in `opts`
// (a string), every key destructured to undefined, and order
// defaulted to 'desc'. So clicking the sort button NEVER actually
// reordered anything regardless of which view you were on. This
// wrapper hides the opts API + the sortedToNewer ↔ order mapping
// behind a single named call.
//
// Date field default:
//   - posts → scheduled_at (the time the user picked for publish)
//   - ideas → createdAt    (ideas don't have a scheduled time of
//                           their own; they were generated on date X)
// `dateKey` overrides per caller (e.g. AllPostsPage might prefer
// postDate after publish).

import { sortByDate } from './sortByDate';

export function sortContent(items, sortedToNewer, opts = {}) {
  const { source = 'post', dateKey } = opts;
  const key = dateKey || (source === 'idea' ? 'createdAt' : 'scheduled_at');
  // `sortedToNewer === true` → newest items first (descending). The
  // default (false) is oldest-first to match the prior UI default the
  // header sort icon assumed.
  const order = sortedToNewer ? 'desc' : 'asc';
  return sortByDate(items, { key, order });
}
